module.exports = __webpack_public_path__ + "app/principal/modals/admin-creation-error-modal-2z6wdCqr.html";